import FirebasePage from "./FirebasePage";
export default FirebasePage;
